module.exports = __webpack_public_path__ + "img/activity-queue.e31b9748.svg";